import { LitElement, css, html } from 'lit';
import { createCreatorProfile, getCreatorProfile } from '../helpers/api/creator-profile-api';
import { customElement, query } from 'lit/decorators';

import { FormInput } from './theme/form-input';
import organizationInfo from '../helpers/state/organization-info';
import { getMainPage } from '../helpers/page-name';

@customElement('add-creator-profile-modal')
export class AddCreatorProfileModal extends LitElement {
    private readonly amplitude_callsite: string = 'Add Creator Profile Modal';

    @query('#creatorProfileName')
    creatorProfileNameElement!: FormInput;



    private async handleSubmit(inputValue: string) {
        const creatorProfileName = inputValue.trim();

        await getMainPage().errorToastElement?.tryOrErrorToast(async () => {
            const creatorProfileResponse = await createCreatorProfile(this.amplitude_callsite,  { username: creatorProfileName, organization_id: organizationInfo.organization?._id, custom_urls: []});

            const creatorProfile = await getCreatorProfile(this.amplitude_callsite, creatorProfileResponse._id.$oid);

            this.dispatchEvent(
                new CustomEvent('on-add-creator-profile', {
                    detail: {
                        creatorProfile,
                    },
                    bubbles: true,
                    composed: true
                })
            );


        },
        'Error creating creator profile.'
    );

        this.dispatchEvent(new CustomEvent('close'));

        this.creatorProfileNameElement.formInputElement.value = '';
    }

    private async handleSave() {
        if (this.creatorProfileNameElement.value) {
            await this.handleSubmit(this.creatorProfileNameElement.value);
        }
    }

    private handleCancel() {
        this.dispatchEvent(new CustomEvent('close'));
    }

    render() {
        return html`
            <div class="add-modal__wrapper">
                <h2 class="add-modal__title">
                    Add Creator Profile
                </h2>
                <div>
                    <form-input
                        prefix="@"
                        class="add-modal__input"
                        id="creatorProfileName"
                        type="text"
                        placeholder="Input Creator Name"
                        maxLength="50"
                        minLength="10"
                        @submit="${async (e: any) => await this.handleSubmit(e.detail)}">
                    </form-input>
                </div>
                <div class="add-modal__actions">
                    <form-button variant="social" @click="${this.handleCancel}">
                        Cancel
                    </form-button>
                    <form-button class="form-btn" @click="${this.handleSave}">Save</form-button>
                </div>
                <error-toast id="errorToast"></error-toast>
            </div>
        `;
    }

    static get styles() {
        return css`
            .add-modal__wrapper {
                padding: 0.5rem 1.5rem 1rem;
            }

            .add-modal__title {
                margin-bottom: 1.25rem;
                color: var(--main-primary-color);
                display: flex;
                align-items: center;
                justify-content: center;
            }

            mwc-icon {
                width: 2rem;
            }

            .add-modal__input {
                width: 550px;
                max-width: 100%;
                display: block;
            }

            .add-modal__actions {
                margin-top: 1rem;
                display: flex;
                justify-content: space-between;
            }
        `;
    }
}
